import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import useOverlayHistory from 'services/useOverlayHistory';

function ModalProjectForm({ isOpen, onClose, onSubmit, initial = null, submitting }) {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const requestClose = useOverlayHistory(isOpen, onClose, { stateKey: 'qappProjectForm' });

  useEffect(() => {
    if (!isOpen) return;
    setName(initial?.name || '');
    setDescription(initial?.description || '');
  }, [isOpen, initial]);

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    onSubmit({ name: name.trim(), description: description.trim() });
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4" onMouseDown={requestClose}>
      <div
        className="bg-white rounded-2xl shadow-xl w-full max-w-md max-h-[90vh] overflow-y-auto"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-4 py-3 border-b">
          <h3 className="text-lg font-semibold">{initial ? 'Edit project' : 'New project'}</h3>
          <button type="button" onClick={requestClose} className="p-1 rounded-lg hover:bg-gray-100">
            <X className="h-6 w-6 text-gray-600" strokeWidth={2} />
          </button>
        </div>
        <form onSubmit={handleSubmit} className="p-4 space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
            <input
              className="w-full border rounded-xl px-3 py-2 text-sm"
              value={name}
              onChange={(e) => setName(e.target.value)}
              maxLength={200}
              autoFocus
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
            <textarea
              className="w-full border rounded-xl px-3 py-2 text-sm min-h-[88px]"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>
          <div className="flex justify-end gap-2 pt-2">
            <button type="button" onClick={requestClose} className="px-4 py-2 rounded-xl border border-gray-300 text-gray-700">
              Cancel
            </button>
            <button
              type="submit"
              disabled={submitting || !name.trim()}
              className="px-4 py-2 rounded-xl bg-blue-700 text-white disabled:opacity-50"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ModalProjectForm;
